function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import CImg from '../image/CImg'; //component - CoreUI / CCardImg

var CCardImg = function CCardImg(props) {
  var variant = props.variant,
      rest = _objectWithoutPropertiesLoose(props, ["variant"]);

  var classSuffix = variant !== 'full' ? "-" + variant : '';
  return /*#__PURE__*/React.createElement(CImg, _extends({}, rest, {
    className: ["card-img" + classSuffix, rest.className]
  }));
};

CCardImg.propTypes = process.env.NODE_ENV !== "production" ? {
  variant: PropTypes.oneOf(['', 'top', 'bottom', 'full'])
} : {};
CCardImg.defaultProps = {
  variant: 'full'
};
export default CCardImg;